import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { Notifications as BellIcon } from '@mui/icons-material';
import { motion } from 'framer-motion';
import { useNotices } from '../../hooks/useNotices';
import NoticeCard from './NoticeCard';

const MotionBox = motion(Box);

/**
 * 메인 페이지 공지사항 섹션
 * DevicePurchaseSection ↔ BlanccoSection 사이 배치
 * displayType: 'card'인 공지만 표시
 * 공지가 없으면 섹션 자체를 숨김
 */
const NoticeSection: React.FC = () => {
  const { cardNotices } = useNotices();

  if (cardNotices.length === 0) return null;

  return (
    <Box
      sx={{
        py: { xs: 4, md: 10 },
        background: 'linear-gradient(180deg, #f8fafc 0%, #ffffff 100%)',
      }}
    >
      <Box sx={{ maxWidth: { xs: '100%', md: '50%' }, mx: 'auto', px: { xs: 2, md: 0 } }}>
        {/* 섹션 헤더 */}
        <MotionBox
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          sx={{ textAlign: 'center', mb: { xs: 2.5, md: 6 } }}
        >
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 1.5,
              mb: 2,
            }}
          >
            <Box
              sx={{
                width: 44,
                height: 44,
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #eff6ff, #dbeafe)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <BellIcon sx={{ fontSize: 22, color: '#2563eb' }} />
            </Box>
            <Typography
              fontWeight={800}
              sx={{
                fontSize: { xs: '1.4rem', md: '1.8rem' },
                color: '#0f172a',
                letterSpacing: '-0.5px',
              }}
            >
              공지사항
            </Typography>
            <Chip
              label={cardNotices.length}
              size="small"
              sx={{
                bgcolor: '#ef4444',
                color: '#fff',
                fontWeight: 800,
                fontSize: 11,
                height: 22,
                minWidth: 22,
              }}
            />
          </Box>
          <Typography sx={{ fontSize: { xs: 14, md: 15 }, color: '#64748b' }}>
            다원트레이드의 최신 소식을 확인하세요
          </Typography>
        </MotionBox>

        {/* 카드 그리드 */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)' },
            gap: { xs: 2, md: 2.5 },
            maxWidth: 900,
            mx: 'auto',
          }}
        >
          {cardNotices.map((notice, index) => (
            <NoticeCard key={notice.id} notice={notice} index={index} />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default NoticeSection;
